import { useState } from "react";
import { useTranslations } from "next-intl";
import PropTypes from "prop-types";
import axios from "axios";
import ButtonWithLoading from "../form-fields/ButtonWithLoading";
import Input from "../form-fields/Input";
import RateLimitError from "../errors/RateLimitError";

export default function LoginForm({ onSuccess }) {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isRateLimited, setIsRateLimited] = useState(false);
  const t = useTranslations("Account");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsRateLimited(false);
    setIsLoading(true);

    try {
      const response = await axios.post("/api/auth/login", formData);

      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        if (onSuccess) {
          onSuccess(response.data);
        }
      }
    } catch (error) {
      if (error.response?.status === 429) {
        setIsRateLimited(true);
      } else {
        setError(error.response?.data?.message || t("error_invalid_credentials"));
      }
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <Input
        title={t("user_or_email")}
        type="text"
        name="username"
        value={formData.username}
        handleChange={handleChange}
        required
        data-testid="login-username"
      />
      <Input
        title={t("password")}
        type="password"
        name="password"
        value={formData.password}
        handleChange={handleChange}
        required
        data-testid="login-password"
      />
      {isRateLimited && <RateLimitError />}
      {error && !isRateLimited && (
        <div className="text-red-500 text-sm mt-2" data-testid="login-error">
          {error}
        </div>
      )}
      <ButtonWithLoading
        type="submit"
        isLoading={isLoading}
        text={t("login")}
        loadingText={t("loading")}
        className="w-full"
        data-testid="login-submit"
      />
    </form>
  );
}

LoginForm.propTypes = {
  onSuccess: PropTypes.func,

};